module.exports = __webpack_public_path__ + "static/LandingBG-1119d4b428864152a7d2443ba9f820d0.jpg";